import { useEffect } from "react";
import { useUser } from "../lib/user";
import { setCookie } from "../utils/cookies";
import Popup from "./popup";
import { UserType } from "../lib/user";

export default function UserPopup() {
  const { user } = useUser();
  useEffect(() => {
    setCookie({ name: "userAlert", value: "true" });
  }, []);
  return (
    <>
      {user?.type === UserType.Commesso && (
        <Popup btnLabel="Ok, chiudi">
          <h2 className="text-lg leading-6 font-medium text-gray-900">
            Attenzione!
          </h2>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Gentile operatore, Il 10/05 il documento “Lettera incarico
              Mediaworld” è stato modificato. Qualora sia stata stampata la
              versione precedente, va scartata e sostituita con quella nuova.
              Per eventuali dubbi, è possibile scrivere a info@spartantech.it.
              Grazie e buon lavoro!{""}
            </p>
            <p>
              <a
                href={`${process.env.REACT_APP_DOCS_URL}${user?.asseveratore}/3. Lettera Incarico Mediaworld.docx`}
                target="_blank"
                className="font-extrabold	text-indigo-600 py-4"
                rel="noreferrer"
              >
                Clicca qui per scaricare la nuova versione
              </a>
            </p>
          </div>
        </Popup>
      )}
    </>
  );
}
